import { invalidateMenuCache } from '@fff-web/fff-global-nav';
import { invalidateUserCache, invalidateUserInfoServerCache } from '@fff-web/fff-utilities';
import { invalidateNavbarProfileCache } from '../services/member-caches';
import { syncDelay } from './index';

const invalidateCaches = async () => {
  invalidateUserCache();
  syncDelay(1000);
  invalidateMenuCache();
  syncDelay(4000);
  await Promise.all([invalidateUserInfoServerCache(), invalidateNavbarProfileCache()]);
};

export default invalidateCaches;
